import * as _ from "lodash"

import {ISearch, ISearchProfile} from "../PA.UIM.Core/PA.UIM.Core.IF.Search";
import {WB_CustomerTypeRow} from "../PA.Core/PAdbSchemaRows";
import {CustomerManagerSearchProfile} from "./CustomerManagerSearch";


// Single popup offering a choice of several Customer Types to search by (e.g. BillTo, PayTo, PlanTo, ...),
// unlike CustomerManagerSearch which is scoped to one Customer Type.
export class CustomerTypesSearch
    implements ISearch {
    constructor(wbMDSetId: number, customerTypeRows: WB_CustomerTypeRow[]) {
        this.searchProfiles = _.map(_.filter(customerTypeRows, (ctr) => !_.isEmpty(ctr.cif.CUSTM_ID)), (ctr) => {
            let custmId: string = <string>ctr.cif.CUSTM_ID
            return new CustomerManagerSearchProfile(wbMDSetId, custmId, ctr, custmId, ctr.cif.CUSTM_NAME || custmId)
        })
    }

    searchName = "Select Customer"
    renderOptions = {ui5ResourceId: "CustomerTypesSearch"}
    searchProfileIdDefault = ""
    searchProfiles: ISearchProfile[] = []
    autoSearch = true

}
